

import { Component,Prop,Watch, BaseMixins } from '@/lib';

import Hicon from '@/components/hicon/hicon.vue'

//ָ��side-menu-itemȫ�������������������Ⱦ�����˵�������
@Component({name:"side-menu-item", components:{Hicon}})
export default class SideMenuItem extends BaseMixins {
    @Prop({type:Object,default:{}}) parentItem:any;
    @Prop({type:String,default:'dark'}) theme:string;
    @Prop({type:Number}) iconSize:number;

    get parentName () {
      return this.parentItem.name
    }
    get children () {
      return this.parentItem.children
    }
    get textColor () {
      return this.theme === 'dark' ? '#fff' : '#495060'
    }

    showTitle (item) {
      return this.L(item.meta.title)
    }

    showChildren (item) {
       let result = item.children && (item.children.length > 1 || (item.meta && item.meta.showAlways) || (item.children.length == 1 && item.children.some(el => el.children.length > 1)))
      return result
    }

    getNameOrHref (item, children0) {
      let itemName:string = '';

      if(item.href){
        itemName = `isTurnByHref_${item.href}`;
      } else if(children0){
         let firstChild = item.children[0];
         if(firstChild.meta && firstChild.meta.defaultChild){
           itemName = firstChild.meta.defaultChild;
         }else{
           itemName = firstChild.name;
         }
      } else if(item.meta && item.meta.defaultChild){
        itemName = item.meta.defaultChild;
      }else {
        itemName = item.name;
      }
      //return item.href ? `isTurnByHref_${item.href}` : (children0 ? item.children[0].name : item.name)
      return itemName;

      //return item.href ? `isTurnByHref_${item.href}` : (children0 ? item.children[0].name : item.name)
    }
}
